'use client'

import { cn } from '@/_lib/utils'

/** Outer slot matching mobile header arrows — keeps desktop progress aligned. */
export const ORDER_PROGRESS_ARROW_OUTER_CLASS =
	'flex h-8 w-8 shrink-0 items-center justify-center'

/** OS / site back (direct-order single-step header). */
export function AOrderProgressBrowserBackButton() {
	return (
		<button
			type='button'
			onClick={() => window.history.back()}
			className={cn(
				'flex h-8 w-8 items-center justify-center rounded-full text-white transition-[transform,colors] duration-200',
				'cursor-pointer bg-medante-purple-dark hover:bg-[#3d2b63]',
				'hover:scale-105 active:scale-95 motion-reduce:hover:scale-100 motion-reduce:active:scale-100'
			)}
			aria-label='Späť'
		>
			<svg className='sico h-3 w-3' aria-hidden>
				<use href='/assets/layout/icons.svg#s_ar2_l' />
			</svg>
		</button>
	)
}

type AOrderProgressStepNavBackButtonProps = {
	disabled: boolean
	onClick: () => void
	ariaLabel?: string
}

/** Previous funnel step — same chrome as mobile progress. */
export function AOrderProgressStepNavBackButton({
	disabled,
	onClick,
	ariaLabel = 'Predchádzajúci krok'
}: AOrderProgressStepNavBackButtonProps) {
	return (
		<button
			type='button'
			disabled={disabled}
			onClick={onClick}
			className={cn(
				'flex h-8 w-8 items-center justify-center rounded-full text-white transition-[transform,colors] duration-200',
				'enabled:hover:scale-105 enabled:active:scale-95 motion-reduce:enabled:hover:scale-100 motion-reduce:enabled:active:scale-100',
				disabled
					? 'cursor-not-allowed bg-medante-purple-dark/35 text-white/60'
					: 'cursor-pointer bg-medante-purple-dark hover:bg-[#3d2b63]'
			)}
			aria-label={ariaLabel}
		>
			<svg className='sico h-3 w-3' aria-hidden>
				<use href='/assets/layout/icons.svg#s_ar2_l' />
			</svg>
		</button>
	)
}

type AOrderProgressStepNavForwardButtonProps = {
	disabled: boolean
	onClick: () => void
	ariaLabel?: string
}

/** Next funnel step — same chrome as mobile progress. */
export function AOrderProgressStepNavForwardButton({
	disabled,
	onClick,
	ariaLabel = 'Ďalší krok'
}: AOrderProgressStepNavForwardButtonProps) {
	return (
		<button
			type='button'
			disabled={disabled}
			onClick={onClick}
			className={cn(
				'flex h-8 w-8 items-center justify-center rounded-full text-white transition-[transform,colors] duration-200',
				'enabled:hover:scale-105 enabled:active:scale-95 motion-reduce:enabled:hover:scale-100 motion-reduce:enabled:active:scale-100',
				disabled
					? 'cursor-not-allowed bg-medante-purple-dark/35 text-white/60'
					: 'cursor-pointer bg-medante-purple-dark hover:bg-[#3d2b63]'
			)}
			aria-label={ariaLabel}
		>
			<svg className='sico h-3 w-3' aria-hidden>
				<use href='/assets/layout/icons.svg#s_ar2_r' />
			</svg>
		</button>
	)
}
